import React from 'react';

import withClass from '../../../../../hoc/withClass';
import logo from '../../../../../assets/images/eboard-logo.png';

const hidden = () => (
    <img className="brand-img" src={logo} alt="eBoard Logo"/>
);

export default withClass(hidden, 'brand hidden-md-up');